import { z } from 'zod';
import { VoiceAIAgentReason } from './voice-ai.enums';

export const VoiceScenarioSchema = z.object({
  id: z.string(),
  question: z.string(),
  answer: z.string(),
  category: z.string(),
  enabled: z.boolean().default(true),
});

export const SelectableDataSourceSchema = z.object({
  key: z.string(),
  name: z.string(),
});

export const VoiceAIFormDataSchema = z.object({
  scenarios: z.array(VoiceScenarioSchema).default([]),
  dataSources: z.array(SelectableDataSourceSchema).default([]),
});

export const VoiceSettingsSchema = z.object({
  agentLanguage: z.string().min(1),
  welcomeMessage: z.string().min(1),
  knowledgeBase: z.string().min(1),
  tone: z.string().min(1),
  transferDuringOfficeHours: z.string().min(1),
  transferOutsideOfficeHours: z.email(),
});

export const VoiceConfigurationDataSchema = z.object({
  scenarios: z.array(VoiceScenarioSchema),
  settings: VoiceSettingsSchema,
});

export const VoiceAIAgentSchema = z.object({
  agentName: z.string(),
  agentId: z.string(),
});

export const VoiceAIAgentDataSchema = z.object({
  agents: VoiceAIAgentSchema.array(),
  defaultAgentId: z.string().optional(),
  // * Absent when there is nothing to say. Only the strict per-company action
  // * fills it - the unfiltered workspace list has no assignment to report on.
  reason: z.enum(VoiceAIAgentReason).optional(),
});

export const VoiceStudioSettingsSchema = z.object({
  assignedAgentIds: z.array(z.string()),
});

export const VoiceStudioSettingsResponseSchema = z.object({
  assignedAgentIds: z.array(z.string()).optional(),
});

export const VoiceMetricsBackfillSchema = z.object({
  from: z.string(),
  to: z.string().optional(),
});

export const VoiceMetricsBackfillResponseSchema = z.object({
  conversationsFound: z.number(),
  written: z.number(),
  skipped: z.number(),
});
